export default "__VITE_ASSET__Du7szk8o__"